<template>
    <div>
        <div v-if="!comm_log_loaded && !load_error" class="text-center gray-600 py-3">
            <b-spinner small class="mr-2" />로그를 불러오는 중입니다.
        </div>
        <div v-else-if="load_error" class="text-center py-3">
            <div class="text-danger mb-2">로그를 불러오지 못했습니다.</div>
            <b-button size="sm" variant="dark-border" @click="readCompanyCommLog">다시 시도</b-button>
        </div>
        <div v-else-if="commlogs.length === 0" class="text-center gray-600 py-3">등록된 로그가 없습니다.</div>
        <div v-for="(item, idx) in commlogs"
            :key="item.id"
            class="mb-2"
            >
            <div v-if="commlogs.length > 0 && item.author_id !== null" class="f-90 gray-600">
                {{ item.author_name }}, {{item.time_stamp}}
            </div>
            <template v-if="is_editing[idx] == false">
                <b-card class="px-3 py-2 bgray-200" v-html="item.comment"></b-card>
            </template>
            <template v-else>
                <b-form-textarea  v-model="item.comment" rows="3" /> 
            </template>
            <div class="text-right pt-1">
                <template v-if="is_editing[idx]==false">
                    <b-button variant="dark-border" size="sm" class="mr-2" @click="toggleEdit(idx)"><fa icon="pen"></fa></b-button>
                    <b-button variant="dark-border" size="sm" @click="handleDelete(item, idx)"><fa icon="trash-alt"></fa></b-button>
                </template>
                <template v-else>                
                    <b-button class="mr-2" size="sm"  @click="toggleEdit(idx)">취소</b-button>
                    <b-button variant="blue" size="sm"  @click="handleSave(item, idx)">저장</b-button>
                </template>
            </div>
        </div>

        <b-button variant="blue" class="mb-2" @click="addNewLog">+ 새 로그 추가</b-button>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getErrorMessage } from '@core/utils/api/errorMessage'

export default {
    props: {
        comment_company: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            commlogs: [],
            is_editing: [],
            comm_log_loaded: false,
            load_error: false
        }
    },
    computed:{
        ...mapState('project_code',['is_project_codes_loaded','now_project']),
        ...mapState(['user_id'])

    },
    async created () {
        await this.readCompanyCommLog()
    },
    beforeDestroy(){
        this.comm_log_loaded = false
        this.commlogs = []
    },
    methods:{
        async readCompanyCommLog () {
            const { company_id , project_code , campaign_id } = this.comment_company
            this.load_error = false
            try {
                const response = await this.$axios.get('/read_company_comm_log', {
                    params : {
                        company_id, project_code, campaign_id
                    }
                })
                this.commlogs = response.data
                this.is_editing = this.commlogs.map(() => false)
                this.comm_log_loaded = true
            } catch (error) {
                this.load_error = true
            }

        },
        async handleSave (item, idx) {
            if (item.comment !== null && item.comment !== '') {
                // 저장 실패 시 편집 상태를 유지해 입력값을 잃지 않게 한다
                if (await this.saveCommLog(item, idx)) this.is_editing.splice(idx, 1, false)
            } else {
                alert('내용을 입력해 주세요')
            }
        },
        async saveCommLog (item, idx) {
            // const path = this.$store.state.backend_host + '/save_company_comm_log'
            let formData = new FormData
            if (item.comment_id) formData.append('comment_id', item.comment_id)
            formData.append('author_id', this.user_id)
            formData.append('comment', item.comment)
            formData.append('company_id', item.company_id)
            formData.append('project_code', item.project_code)
            if (item.campaign_id !== null) formData.append('campaign_id', item.campaign_id)

            let response
            try {
                response = await this.$axios.post('/save_company_comm_log', formData)
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '저장 실패', getErrorMessage(error, '커뮤니케이션 로그를 저장하지 못했습니다. 입력한 내용은 유지됩니다.'))
                return false
            }
            if (response.data.code === 'success') {
                this.$EventBus.$emit('toast-success', '성공', '커뮤니케이션 로그를 저장하였습니다.')
                let new_obj = {
                    comment_id : response.data.comment_id,
                    author_id : response.data.author_id,
                    author_name : response.data.author_name,
                    comment: response.data.comment,
                    project_code: response.data.project_code,
                    campaign_id : response.data.campaign_id,
                    time_stamp : response.data.time_stamp
                }
                this.commlogs.splice(idx, 1, new_obj)
                return true
            }
            this.$EventBus.$emit('toast-failure', '저장 실패', response.data.msg || '커뮤니케이션 로그를 저장하지 못했습니다. 입력한 내용은 유지됩니다.')
            return false
        },
        toggleEdit(idx){
            if (this.is_editing[idx] === false) {
                this.is_editing.splice(idx, 1, true)
            } else {
                this.is_editing.splice(idx, 1, false)
            }
        },
        async handleDelete (item, idx) {
            if (confirm(item.author_name+' / '+item.time_stamp+' 로그를 삭제하시겠습니까?') === true) {
                let formData = new FormData
                formData.append('comment_id', item.comment_id)
                try {
                    const response = await this.$axios.post('/delete_comm_log', formData)
                    if (response.data.code === 'success') {
                        this.$EventBus.$emit('toast-success','성공', response.data.msg)
                        this.is_editing.splice(idx, 1)
                        this.commlogs.splice(idx, 1)
                    } else {
                        this.$EventBus.$emit('toast-failure', '삭제 실패', response.data.msg || '로그를 삭제하지 못했습니다.')
                    }
                } catch (error) {
                    this.$EventBus.$emit('toast-failure', '삭제 실패', getErrorMessage(error, '로그를 삭제하지 못했습니다.'))
                }
            }
        },
        addNewLog(){
            let new_obj = {}
            new_obj.company_id = this.comment_company.company_id
            new_obj.project_code = this.comment_company.project_code
            new_obj.campaign_id = this.comment_company.campaign_id
            new_obj.comment = ''
            this.commlogs.push(new_obj)
        }

    }
}
</script>

<style>

</style>